import { render, staticRenderFns } from "./CodeInfo.vue?vue&type=template&id=a61628c8&scoped=true"
import script from "./CodeInfo.vue?vue&type=script&lang=js"
export * from "./CodeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61628c8",
  null
  
)

export default component.exports